import { handleQuery } from '../utils/request'

export const INCIDENT_API = `${process.env.API_URL}/incident/graphql`

const INCIDENT_VALUES = {
  _id: true,
  number: true,
  fileType: true,
  fileName: true,
  device: {
    _id: true,
    name: true,
  },
  mediaLink: true,
  type: true,
  thumbnail: true,
  status: true,
  assignedTo: {
    _id: true,
    firstName: true,
    lastName: true,
  },
  severity: true,
  dismissed: true,
  tags: true,
  createdAt: true,
  locationName: true,
  updatedAt: true,
  metadata: true,
  aiMetadata: {
    objects: true,
    activities: true,
    ocrText: true,
    sentiment: true,
    summary: true
  },
  application: {
    _id: true,
    name: true,
  },
  comments: {
    _id: true,
    description: true,
    createdBy: {
      _id: true,
      firstName: true,
      lastName: true,
    },
    createdAt: true,
    childComments: {
      _id: true,
      description: true,
      createdBy: {
        _id: true,
        firstName: true,
        lastName: true,
      },
      createdAt: true
    }
  },
  incidentBoardId: true,
  isUseful: true,
  profile: {
    _id: true,
    name: true,
  }
}

export const INCIDENT_VALUES_NO_THUMBNAIL = { ...INCIDENT_VALUES }
delete INCIDENT_VALUES_NO_THUMBNAIL.thumbnail

const INCIDENT_MEDIA_LINK_VALUES = {
  _id: true,
  mediaLink: true,
}

const INCIDENT_BOARD_LIST_VALUES = {
  _id: true,
  name: true,
  description: true,
  tags: true,
  processSettings: {
    label: true,
    colour: true,
    stage: true,
    _id: true
  },
  cleanupInterval: true,
  createdAt: true,
  updatedAt: true,
  application: {
    _id: true,
    name: true,
  },
  sortSettings: {
    key: true,
    order: true,
  },
  createdBy: {
    _id: true,
    firstName: true,
    lastName: true,
  },
  locations: {
    _id: true,
    name: true,
    visibility: true
  },
  incidentAnalyticsSettings: {
    locations: true,
    assignees: true,
    devices: true,
    timeRange: true
  },
  aiContext: {
    ignoredDetections: true,
    incidentIdentifier: true,
    usageDetails: true
  }
}

const INCIDENT_ANALYTICS_VALUES = {
  totalCompleted: true,
  totalIncidents: true,
  totalDismissed: true,
  totalCreated: true,
  resolutionProgress: true,
  completionRatePerDay: true,
  avgResolutionTimeInHours: true,
  avgCreatedPerDay: true,
  totalActioned: true
}

const INCIDENT_CHART_VALUES = {
  metricsCount: true,
  groupBy: true,
  metricColumns: true,
  metricsData: {
    values: true,
    group: true
  }
}

const INCIDENT_HOME_PAGE_CHART_VALUES = {
  ...INCIDENT_CHART_VALUES,
  interval: true
}

const INCIDENT_WORKER_VALUES = {
  id: true,
  workspaceId: true,
  incidentBoardId: true,
  enabled: true,
  purpose: true,
  runOn: {
    trigger: true,
    tags: true
  },
  modes: {
    dismissFalseDetectionsEnabled: true,
    sceneSummary: {
      enabled: true,
      instructions: true,
      include: true
    },
    objectAndActivities: {
      enabled: true,
      focusItems: {
        item: true,
        instructions: true
      },
      outputInformation: {
        system: true,
        custom: true
      }
    },
    sentimentAnalysis: {
      enabled: true,
      analyze: true,
      sentimentTypes: true,
      instructions: true
    },
    ocrText: {
      enabled: true,
      language: true,
      textSources: {
        system: true,
        other: true
      }
    }
  },
  actions: {
    recommendTags: {
      enabled: true,
      tagsToSet: {
        tag: true,
        instructions: true
      }
    },
    setImpact: {
      enabled: true,
      impact: {
        level: true,
        instructions: true
      }
    },
    moveToColumn: {
      enabled: true,
      columns: {
        column: true,
        instructions: true
      }
    },
    assignToUser: {
      enabled: true,
      users: {
        userId: true,
        instructions: true
      }
    },
  },
  createdBy: {
    _id: true,
    firstName: true,
    lastName: true
  }
}

export function getIncidentWorker(params) {
  const query = {
    query: {
      incidentWorker: {
        __args: params,
        ...INCIDENT_WORKER_VALUES
      }
    }
  }
  return handleQuery(query, INCIDENT_API)
}

export function getIncidentHomeChart() {
  const query = {
    query: {
      incidentHomePageChart: {
        ...INCIDENT_HOME_PAGE_CHART_VALUES
      }
    }
  }
  return handleQuery(query, INCIDENT_API)
}

export function getIncidentsHomePage(params) {
  const query = {
    query: {
      incidentsHomePage: {
        __args: params,
        count: true,
        data: INCIDENT_VALUES,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function getIncidentTags(args) {
  const query = {
    query: {
      incidentTags: {
        __args: args
      }
    }
  }
  return handleQuery(query, INCIDENT_API)
}

export function updateIncidentTags(args) {
  const query = {
    mutation: {
      bulkUpdateIncidentTags: {
        __args: args,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function getIncidentBoardTags(args) {
  const query = {
    query: {
      incidentBoardTags: {
        __args: args
      }
    }
  }
  return handleQuery(query, INCIDENT_API)
}

export function updateIncidentBoardTags(args) {
  const query = {
    mutation: {
      bulkUpdateIncidentBoardTags: {
        __args: args,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function updateIncidentWorkerSettings(args) {
  const query = {
    mutation: {
      updateIncidentWorkerSettings: {
        __args: args,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function deleteIncidentBoards(args) {
  const query = {
    mutation: {
      deleteIncidentBoards: {
        __args: args,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function getIncidentBoards(params) {
  const query = {
    query: {
      incidentBoards: {
        __args: params,
        count: true,
        data: INCIDENT_BOARD_LIST_VALUES
      }
    }
  }
  return handleQuery(query, INCIDENT_API)
}

export function getIncidentBoard(params) {
  const query = {
    query: {
      incidentBoard: {
        __args: params,
        ...INCIDENT_BOARD_LIST_VALUES
      }
    }
  }
  return handleQuery(query, INCIDENT_API)
}

export function getIncidentAnalytics(params) {
  const query = {
    query: {
      incidentAnalytics: {
        __args: params,
        ...INCIDENT_ANALYTICS_VALUES
      }
    }
  }
  return handleQuery(query, INCIDENT_API)
}

export function getIncidentChart(params) {
  const query = {
    query: {
      incidentChart: {
        __args: params,
        ...INCIDENT_CHART_VALUES
      }
    }
  }
  return handleQuery(query, INCIDENT_API)
}

export function getIncidentBoardDevices(params) {
  const query = {
    query: {
      incidentBoardDevices: {
        __args: params,
        ...INCIDENT_VALUES.device
      }
    }
  }
  return handleQuery(query, INCIDENT_API)
}

export function getIncidentBoardUsers(params) {
  const query = {
    query: {
      incidentBoardUsers: {
        __args: params,
        ...INCIDENT_VALUES.assignedTo
      }
    }
  }
  return handleQuery(query, INCIDENT_API)
}

export function updateIncidentBoard(args) {
  const query = {
    mutation: {
      updateIncidentBoard: {
        __args: args,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function getIncidents(params, fields = INCIDENT_VALUES) {
  const query = {
    query: {
      incidents: {
        __args: params,
        count: true,
        data: fields,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function exportIncidentsCsv(params) {
  const query = {
    query: {
      exportIncidentsCsv: {
        __args: params,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function getIncidentCount(params) {
  const query = {
    query: {
      incidents: {
        __args: params,
        count: true,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function getIncident(params) {
  const query = {
    query: {
      incident: {
        __args: params,
        ...INCIDENT_VALUES,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function updateIncident(args) {
  const query = {
    mutation: {
      updateIncident: {
        __args: args,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function createIncidentBoard(args) {
  const query = {
    mutation: {
      createIncidentBoard: {
        __args: args,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function sendVideoToCollection(args) {
  const query = {
    mutation: {
      sendVideoToCollection: {
        __args: args,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function createComment(args) {
  const query = {
    mutation: {
      createComment: {
        __args: args,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function deleteComment(args) {
  const query = {
    mutation: {
      deleteComment: {
        __args: args,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function updateIncidents(args) {
  const query = {
    mutation: {
      updateIncidents: {
        __args: args,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function migrateIncidents(args) {
  const query = {
    mutation: {
      migrateIncidents: {
        __args: args,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function updateComment(args) {
  const query = {
    mutation: {
      updateComment: {
        __args: args,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function deleteIncident(args) {
  const query = {
    mutation: {
      deleteIncident: {
        __args: args,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function deleteIncidents(args) {
  const query = {
    mutation: {
      deleteIncidents: {
        __args: args,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function getIncidentMediaLink(params) {
  const query = {
    query: {
      incident: {
        __args: params,
        ...INCIDENT_MEDIA_LINK_VALUES,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}

export function createDemoIncident(args) {
  const query = {
    mutation: {
      createDemoIncident: {
        __args: args,
      },
    },
  }
  return handleQuery(query, INCIDENT_API)
}